import api from "../../config/api";
import http from "../http";
import { DrugDiseaseResponse } from "../../interfaces/api/drugs";

const drugs = {
  /**
   * Fetches all sections of content for a single drug or disease.
   * @param id - The ID of the drug.
   * @returns Promise<DrugItemDetailsType[] | null>
   */
  getDrugDetails: async (id: number): Promise<DrugDiseaseResponse> => {
    return http.get(`${api.drugs}/${id}`);
  },
};

export default drugs;
